import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { IUseHardwareFilter } from '../../../../ts/interface/hardware.interface';
import { getHardwareV2, HardwareV2Response } from '../../../../api/hardwareV2';

/**
 * Hook to fetch hardware using the V2 API (legacy management API)
 *
 * @param parameters - Filter parameters for the hardware query
 * @param options - React Query options
 */
const useHardwareV2 = (
  parameters?: IUseHardwareFilter,
  options?: Omit<
    UseQueryOptions<HardwareV2Response | null, Error>,
    'queryKey' | 'queryFn'
  >
) => {
  return useQuery({
    queryKey: ['hardwareV2', parameters],
    queryFn: () => getHardwareV2(parameters),
    ...options,
  });
};

export default useHardwareV2;
